(function () {
  window.addEventListener('DOMContentLoaded', () => {
    const activeSubmenuLink = document.querySelector('.collectionSubcategories__listItem--active');
    const subcategoriesList = document.querySelector('.collectionSubcategories__list');

    if (subcategoriesList && activeSubmenuLink) {
      let leftPosition = activeSubmenuLink.offsetLeft;

      if (window.innerWidth <= 640 ) {
        leftPosition -= 24;
      } else {
        leftPosition -= 32;
      }

      subcategoriesList.scrollLeft = leftPosition;
    }
  })
})();

if (!customElements.get('collection-subcategories')) {
  class CollectionSubcategories extends HTMLElement {
    constructor() {
      super();
    }

    removeFilterItem(event) {
      const target = event.target;

      if (target.classList.contains('filtering-list__item')) {
        const filterSection = document.querySelector('.collectionFullpage__filter');
        const filterSectionTag = filterSection.querySelector(`.filtering-list__item[data-value="${target.dataset.value}"]`);
        const applyButton = filterSection.querySelector('.fullpageCollectionFilter__buttonApply');

        if (filterSectionTag) {
          target.remove();
          filterSectionTag.click();
          
          setTimeout(() => {
            const collectionFilter = document.querySelector('collection-filter');
            if (collectionFilter && collectionFilter.updateURLWithFilters) {
              collectionFilter.updateURLWithFilters();
            }
          }, 50);
          
          applyButton.click();
        }
      }
    }

    connectedCallback() {
      this.addEventListener('click', this.removeFilterItem);
    }

    disconnectedCallback() {}
  }

  customElements.define('collection-subcategories', CollectionSubcategories);
}